import Cookies from "js-cookie";
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ProducerMain from "../Components/ProducerMain/ProducerMain";
import CategoryDetails from "../Components/CategoryDetails/CategoryDetails";
import BuyStory from "../Components/BuyStory/BuyStory";
import { getInfo } from "../utils/hooks";
import Stories from "../Components/Stories/Stories";
import Write from "../Components/Write/Write";
import ReaderView from "../Components/ReaderView/ReaderView";
import Report from "../Components/Report/Report";
import Upload from "../Components/Upload/Upload";
import ShortlistStory from "../Components/ShortlistStory/ShortlistStory";
import TopTrending from "../Components/TopTrending/TopTrending";
import TopCritics from "../Components/TopCritics/TopCritics";

const ProducerLayout: React.FC = () => {
    const userInfo = getInfo();

    if (userInfo === null) {
        return <Redirect to="/login" />;
    } else if (Cookies.get("admin")) {
        return <Redirect to="/admin" />;
    } else if (userInfo.intent === "critic") {
        return <Redirect to="/critic" />;
    } else if (userInfo.intent === "writer") {
        return <Redirect to="/writer" />;
    }

    return (
        <Switch>
            <Route
                path="/producer/category/:name"
                component={CategoryDetails}
            />
            <Route path="/producer/story/my" component={Stories} />
            <Route
                path="/producer/story/shortlist"
                component={ShortlistStory}
            />
            <Route path="/producer/story/:id" component={BuyStory} />
            <Route path="/producer/write" component={Write} />
            <Route path="/producer/read/:id" component={ReaderView} />
            <Route path="/producer/report/:id" component={Report} />
            <Route path="/producer/upload" component={Upload} />
            <Route path="/producer/top-trending" component={TopTrending} />
            <Route path="/producer/top-critics" component={TopCritics} />
            <Route path="" exact component={ProducerMain} />
        </Switch>
    );
};

export default ProducerLayout;
